import { ApiButton, Box, Grid, KeyValue, Pill } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentStatus } from '../../../models/PaymentStatus';
import PaymentStatusPill from '../../../components/pills/PaymentStatusPill';
import FormHeader from '../../../components/form-items/FormHeader';
import { SubjectAmendmentSummaryResponse } from '../../../api/candidate/exam/model';
import { usePostSubjectAmendmentPaymentLink } from '../../../api-refactored/group-subject-amendment/usePostSubjectAmendmentPaymentLink';

const fallbackNaForDash = (input: string) => (input === '-' ? 'N/A' : input);

const AmendmentTransaction = ({
  classes,
  summary,
  applicationUUID,
  isGroup,
}: {
  classes: any;
  summary?: SubjectAmendmentSummaryResponse;
  applicationUUID: string;
  isGroup: boolean;
}) => {
  const { t } = useTranslation();
  const { mutate: postPaymentLink, status: paymentLinkStatus } = usePostSubjectAmendmentPaymentLink(
    {}
  );

  if (!summary) {
    return <></>;
  }
  return (
    <Box className={classes.paymentContainer}>
      <FormHeader title={t('amendment->>ViewDetails.Transaction Details')} />
      <KeyValue
        id="cpReferenceNo"
        keyText={t('amendment->>ViewDetails.CP Reference No.')}
        valueText={fallbackNaForDash(summary.transactionDetails.internalRef)}
      />
      <KeyValue
        id="transactionNo"
        keyText={t('amendment->>ViewDetails.Transaction No.')}
        valueText={fallbackNaForDash(summary.transactionDetails.transactionNo)}
      />
      <Grid container direction="row">
        <Grid md={5} sm={12} xs={12}>
          <KeyValue
            id="applicationid"
            keyText={t('amendment->>ViewDetails.Payment Method')}
            valueText={fallbackNaForDash(summary.payment.paymentMode || '')}
          />
        </Grid>
        <Grid md={5} sm={12} xs={12}>
          <KeyValue
            id="nationality"
            keyText={t('amendment->>ViewDetails.Payment Status')}
            valueText={
              isGroup ? (
                <Grid>
                  <PaymentStatusPill paymentStatus={summary.transactionDetails.paymentStatus} />
                  {summary.transactionDetails.paymentStatus === PaymentStatus.PENDING_PAYMENT && (
                    <ApiButton
                      variant="text"
                      color="primary"
                      onClick={() => {
                        postPaymentLink(applicationUUID);
                      }}
                      size="small"
                      status={paymentLinkStatus}
                      className={classes.sendEmailButton}
                    >
                      <IconWithLabel
                        iconName={IconName.email}
                        iconSize="M"
                        label="Send Payment Link"
                      />
                    </ApiButton>
                  )}
                </Grid>
              ) : (
                <Grid>
                  <Pill label={summary.transactionDetails.paymentStatus} variant="positive" />
                </Grid>
              )
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AmendmentTransaction;
